import React from "react";
import "./ErrorSummary.scss";

const fieldLabels: Record<string, string> = {
  searchAddress: "Search address",
  unit: "Unit/Level",
  no: "House/Building number",
  streetName: "Street name",
  city: "City/Suburb",
  state: "State",
  country: "Country",
  postCode: "Postcode",
  propertyType: "Property type",
  landSize: "Land size",
  landSizeUnit: "Land size unit",
  floorArea: "Floor area",
  floorAreaUnit: "Floor area unit",
  bedRooms: "Bedrooms",
  bathRooms: "Bathrooms",
  living: "Living/Study",
  garage: "Garage/Parking",
};

const ErrorSummary = ({ errors }: { errors: Record<string, string> }) => {
  const errorEntries = Object.entries(errors);
  
  if (!errorEntries.length) return null;

  return (
    <>
      <div className="error-summary">
        <div className="error-header">
          <span className="error-icon">!</span>
          <span>Errors in form!</span>
        </div>
        <div className="error-message">
          Please fix the following errors to create the property bank.
        </div>
      </div>
      <div>
        <ul className="error-list">
          {errorEntries.map(([field, message]) => (
            <li key={field}>
              {fieldLabels[field] || field}: {message}
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default ErrorSummary;